/**
 * Fills the quote form with what the customer already picked, so they do not retype it:
 * the product and size they came from (query parameters set by high-variant-quote.js)
 * and whatever is in their cart. Both are optional — with neither, the field is left alone.
 *
 * The cart goes into the visible field rather than being attached behind the scenes, so
 * the same list reaches the customer, the store's email and the CRM copy.
 */
(function () {
  var CART_MAX_ITEMS = 20;

  var field = document.querySelector('[name="contact[Quote Information]"]');
  // A value already in the field is the customer's own, or restored by the browser — never overwrite it.
  if (!field || field.value.trim()) return;

  var written = '';

  function write(value) {
    written = value;
    field.value = value;

    // The theme marks a filled field with this class, which is what lifts the label clear
    // of the text. It sets it while a person types; a value assigned from script does not
    // go through that path, so apply the same state the theme would have applied.
    field.classList.add('form-field-filled');
    ['input', 'change'].forEach(function (type) {
      field.dispatchEvent(new Event(type, { bubbles: true }));
    });
  }

  var params = new URLSearchParams(window.location.search);
  var product = params.get('quote_product');
  var options = params.get('quote_options');

  var lines = [];
  if (product) lines.push('Product: ' + product);
  if (options) {
    options.split('|').forEach(function (part) {
      if (part.trim()) lines.push(part.trim());
    });
  }
  if (lines.length) write(lines.join('\n'));

  function money(cents, currency) {
    return (cents / 100).toFixed(2) + ' ' + currency;
  }

  function formatCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return null;
    var rows = cart.items.slice(0, CART_MAX_ITEMS).map(function (item) {
      var name = item.product_title + (item.variant_title ? ' / ' + item.variant_title : '');
      return '- ' + item.quantity + ' x ' + name + ' - ' + money(item.line_price, cart.currency);
    });
    var hidden = cart.items.length - CART_MAX_ITEMS;
    if (hidden > 0) rows.push('- ...and ' + hidden + ' more');
    // Cart prices come back in the BUYER's currency, not the store's, so name the currency
    // rather than leave a number a manager would read as dollars.
    rows.unshift('Cart (' + cart.item_count + ' items, total ' + money(cart.total_price, cart.currency) + '):');
    return rows.join('\n');
  }

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (response) {
      return response.ok ? response.json() : null;
    })
    .then(function (cart) {
      var block = formatCart(cart);
      if (!block) return;
      // The request is async, so the customer may have started writing in the meantime —
      // their text wins, the cart is simply not added.
      if (field.value !== written) return;
      write(written ? written + '\n\n' + block : block);
    })
    .catch(function () {});
})();
